/* global Blockly */
import React from 'react';
import {paragraphIcon} from "./index";

// everything in init should be ES5
function defineBlock(context) {
    return {
        init: function () {
            this.appendValueInput("TEXT")
                .appendField("set")
                .appendField(new Blockly.FieldImage(paragraphIcon, 30, 30, "paragraph icon", null), 'paragraphIcon')
                .appendField(new Blockly.FieldWidgetsDropdown(context, "paragraph", undefined, '- select -'), "ID")
                .appendField("to");
            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setOutput(false); // add appropriate checks
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Set the display text of the provided paragraph widget.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + '#widget-values');
        },
        onchange: function(){
            if (this.getField('paragraphIcon') && this.getField('paragraphIcon').imageElement_)
                this.getField('paragraphIcon').setTooltip('Paragraph');
        }
    }
}

function defineGenerators() {
    // generators dictionary in ES5
    return {
        'JavaScript': function (block) {
            let id = block.getFieldValue("ID");
            let text = Blockly.JavaScript.valueToCode(block, 'TEXT', Blockly.JavaScript.ORDER_NONE);
            return "Snap.widgets.paragraph.setDisplayText('" + id + "', " + text + ");\n"
        }
    }
}


const SetParagraphText = function (props) {
    let name = "snap_set_paragraph_text";
    SetParagraphText.blockName = name;
    
    Blockly.Blocks[name] = defineBlock(props.context);

    let generators = defineGenerators(props.context);
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    if (props.widgets.length < 1) {
        return null;
    }

    return (
        <block type={name}>
            {props.widget && (props.widget.id !== undefined)
                ? <field name="ID">{props.widget.id}</field>
                : null
            }
            <value name="TEXT">
                <shadow type="text"/>
            </value>
        </block>
    );
}

export default SetParagraphText;